(function () {
  function applyCheckedFromURL() {
    const params = new URLSearchParams(window.location.search);
    const selectedCategoryChild = params.getAll("filter.p.m.category.child");
    const selectedDiscountPercent = params.getAll(
      "filter.p.m.discount.percent"
    );

    // filter.p.m.category.childのchecked、親カテゴリーのopen
    selectedCategoryChild.forEach(function (tagValue) {
      const selector =
        'input[type="checkbox"][name="filter.p.m.category.child"][value="' +
        tagValue +
        '"]';
      document.querySelectorAll(selector).forEach(function (input) {
        input.checked = true;

        let parent = input.closest("details");
        while (parent) {
          parent.open = true;
          parent = parent.parentElement?.closest("details");
        }
      });
    });

    // filter.p.m.discount.percentのchecked
    selectedDiscountPercent.forEach(function (tagValue) {
      const selector =
        'input[type="checkbox"][name="filter.p.m.discount.percent"][value="' +
        tagValue +
        '"]';
      document.querySelectorAll(selector).forEach(function (input) {
        input.checked = true;
      });
    });

    // 選択数を js-filter-selected-count
    const countField = document.getElementById("js-filter-selected-count");
    if (countField) {
      const totalSelected =
        selectedCategoryChild.length + selectedDiscountPercent.length;
      countField.value = totalSelected;
    }
  }

  function removeParamFromURL(key, value) {
    // ??の問題を修正
    let href = window.location.href;
    if (href.includes("??")) {
      href = href.replace(/\?\?/, "?");
    }

    const url = new URL(href);
    const params = url.searchParams;
    const values = params.getAll(key).filter((v) => v !== value);
    params.delete(key);
    values.forEach((v) => params.append(key, v));
    return `${url.pathname}?${params.toString()}`;
  }

  function renderSelectedTagItems() {
    const containers = document.querySelectorAll(
      ".c-collection-filter--selected-list"
    );
    if (!containers.length) return;

    const params = new URLSearchParams(window.location.search);

    // 2種類まとめて取得
    const selectedCategoryChild = params.getAll("filter.p.m.category.child");
    const selectedDiscountPercent = params.getAll(
      "filter.p.m.discount.percent"
    );

    const allSelected = [
      { paramName: "filter.p.m.category.child", values: selectedCategoryChild },
      {
        paramName: "filter.p.m.discount.percent",
        values: selectedDiscountPercent,
      },
    ];

    containers.forEach((container) => {
      // すでに追加済みのタグを削除
      container
        .querySelectorAll('.tag-item--remove[data-tag-source="custom"]')
        .forEach((el) => el.remove());

      allSelected.forEach((group) => {
        group.values.forEach((tagValue) => {
          const input = document.querySelector(
            `input[type="checkbox"][name="${group.paramName}"][value="${tagValue}"]`
          );
          if (!input) return;

          const label = document.querySelector(`label[for="${input.id}"]`);
          // const labelText = label ? label.textContent.trim() : tagValue;
          const labelText = label
            ? label.getAttribute("data-label") || label.textContent.trim()
            : tagValue;
          const url = removeParamFromURL(group.paramName, tagValue);

          const a = document.createElement("a");
          a.className = "button--selected capitalize";
          a.setAttribute("href", url);
          a.setAttribute("data-action", "clear-filters");
          a.setAttribute("aria-label", `Remove ${labelText}`);
          a.innerHTML = `
            <svg aria-hidden="true" focusable="false" class="icon icon-close" viewBox="0 0 16 16" width="10" height="10">
              <path d="M1 1l14 14M15 1L1 15" stroke="currentColor" stroke-width="2" fill="none" />
            </svg>
            ${labelText}
          `;

          const div = document.createElement("div");
          div.className = "tag-item--remove";
          div.setAttribute("data-tag-source", "custom");
          div.appendChild(a);

          container.appendChild(div);
        });
      });
    });
  }

  function countActiveFilters() {
    const form = document.querySelector("#facet-filters-form");
    if (!form) return 0;

    const formData = new FormData(form);
    let count = 0;

    for (const [key, value] of formData.entries()) {
      if (
        (key === "filter.p.m.category.child" ||
          key === "filter.p.m.discount.percent") &&
        value !== ""
      ) {
        count++;
      }
    }

    return count;
  }

  function toggleFilterVisibility() {
    const count = countActiveFilters();
    const selected = document.querySelector(".c-collection-filter--selected");
    const selectedCount = document.querySelector(".js-filter-selected-count");
    const clears = document.querySelectorAll(
      ".c-collection-filter--selected-clear"
    );

    if (selected) {
      selected.classList.toggle("hidden", count < 1);
    }

    // モバイル: 表示分岐と選択数
    if (selectedCount) {
      if (count >= 1) {
        selectedCount.classList.remove("hidden");
        selectedCount.textContent = count;
      } else {
        selectedCount.classList.add("hidden");
        selectedCount.textContent = "";
      }
    }

    // すべての削除の表示分岐
    clears.forEach((clear) => {
      clear.classList.toggle("hidden", count < 2);
    });
  }

  function renderGenderFilterTag() {
    const containers = document.querySelectorAll(
      ".c-collection-filter--selected-list"
    );
    if (!containers.length) return;

    // パスが /collections/{handle}/men または /collections/{handle}/women かチェック
    const pathname = window.location.pathname;
    const genderMatch = pathname.match(/^\/collections\/([^/]+)\/(men|women)$/);

    if (!genderMatch) {
      // パターンに一致しない場合は既存のタグを削除
      containers.forEach((container) => {
        container
          .querySelectorAll('.tag-item--remove[data-tag-source="gender"]')
          .forEach((el) => el.remove());
      });
      return;
    }

    const handle = genderMatch[1];
    const gender = genderMatch[2];

    // 除外: /collections/men または /collections/women
    if (handle === "men" || handle === "women") {
      containers.forEach((container) => {
        container
          .querySelectorAll('.tag-item--remove[data-tag-source="gender"]')
          .forEach((el) => el.remove());
      });
      return;
    }

    // 標準フィルターがある場合はスキップ
    const params = new URLSearchParams(window.location.search);
    if (params.has("filter.p.m.custom.gender_filter")) {
      containers.forEach((container) => {
        container
          .querySelectorAll('.tag-item--remove[data-tag-source="gender"]')
          .forEach((el) => el.remove());
      });
      return;
    }

    // 既存のジェンダータグを削除
    containers.forEach((container) => {
      container
        .querySelectorAll('.tag-item--remove[data-tag-source="gender"]')
        .forEach((el) => el.remove());

      const genderLabel = gender === "men" ? "MEN" : "WOMEN";

      // パスから /men または /women を削除したURLを生成
      const newPathname = pathname.replace(/\/(men|women)$/, "");
      const newUrl = `${newPathname}${window.location.search}`;

      const a = document.createElement("a");
      a.className = "tag__icon tap-area";
      a.setAttribute("href", newUrl);
      a.setAttribute("data-action", "clear-filters");
      a.setAttribute("aria-label", "削除");
      a.innerHTML = `
        <svg focusable="false" width="10" height="10" class="icon icon--close" viewBox="0 0 14 14">
          <path d="M13 13L1 1M13 1L1 13" stroke="currentColor" stroke-width="2" fill="none"></path>
        </svg>
        ${genderLabel}
      `;

      const div = document.createElement("div");
      div.className = "tag-item--remove";
      div.setAttribute("data-tag-source", "gender");
      div.appendChild(a);

      container.appendChild(div);
    });
  }

  function updateFiltersUI() {
    applyCheckedFromURL();
    renderSelectedTagItems();
    renderGenderFilterTag();
    toggleFilterVisibility();
  }

  document.addEventListener("DOMContentLoaded", updateFiltersUI);

  document.addEventListener("facet:rendered", updateFiltersUI);

  window.addEventListener("popstate", function () {
    const targetElement =
      document.querySelector("product-list") ||
      document.querySelector(".c-collection-filter--selected-list");

    if (!targetElement) {
      setTimeout(() => {
        updateFiltersUI();
      }, 200);
      return;
    }

    const observer = new MutationObserver(function () {
      console.log("DOM updated by Shopify, running updateFiltersUI");
      updateFiltersUI();
      observer.disconnect();
    });

    observer.observe(targetElement, {
      childList: true,
      subtree: true,
      attributes: true,
    });

    setTimeout(() => {
      observer.disconnect();
      updateFiltersUI();
    }, 3000);
  });
})();
